<div [formGroup]="formGroup" [class]="config.cssClass">
    <p>{{ config.label }}</p>
</div>
